export enum PatientListColumnsTitles {
  PatientIdentifier = 'patientIdentifier',
  FirstName = 'firstName',
  LastName = 'lastName',
  DateOfBirth = 'dateOfBirth',
  PatientAccountCreatedDateUtc = 'patientAccountCreatedDateUtc',
}
